import axios from "axios";

const uploadImage = async (data) => {
  return axios.post("https://citymall.live/api/media/upload-image", data);
};
// const uploadImage = async (data) => {
//   return axios.post(
//     "https://citymall.live/api/leader/upload-private-image",
//     data,
//   );
// };

export default uploadImage;
